import React from 'react';
import ReactDOM from 'react-dom';
import ProductTags from '../../components/modules/products/ProductTags.jsx';

const renderTags = () => {
    const elements = document.getElementsByClassName('product__tags-container');
    if (elements !== null) {
        if (elements.length > 0) {
            for (let index = 0; index < elements.length; index++) {
                let el = elements[index];
                ReactDOM.render(
                    <ProductTags
                        latestArrival={el.dataset.latestarrival}
                        offer={el.dataset.offer}
                        tags={el.dataset.tags}
                        offerdata={el.dataset.offerdata}
                    />,
                    el
                );
            }
        }
    }
};

renderTags();

window.renderTags = renderTags;
